import { Title } from "../../../common/styles";
import { GpsIco, LocationNameBlock, Section, StyledButton, Block } from "./styled";

const link = "https://maps.app.goo.gl/9xDE4fB2bjM3Aos56";

const AboutLocation = () => {
    return (
        <Section>
            <Block>
                <Title>Де мене знайти?</Title>
                <LocationNameBlock>
                    <GpsIco />
                    Wola, Edwarda Gibalskiego 5, Warsaw, Poland 01-190
                </LocationNameBlock>
                <a target="_blank" rel="noreferrer" href={link}>
                    <StyledButton>Подивитись на карті</StyledButton>
                </a>
            </Block>
            <a target="_blank" rel="noreferrer" href={link}>
                <iframe
                    title="map"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1523.021931924359!2d20.975920520083523!3d52.2402766303594!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ecb7ef499cf9b%3A0xe0a02d3355feef48!2sEdwarda%20Gibalskiego%205%2C%2001-190%20Warszawa!5e0!3m2!1spl!2spl!4v1745007347426!5m2!1spl!2spl"
                    width="400"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen={true}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </a>
        </Section>
    );
};

export default AboutLocation;